import { History, Location } from 'history';
import { getSessionStorage } from 'mk2/helpers/storages';
import { HistoryLocationState } from 'mk2/services/browserHistory';
import React from 'react';

interface OwnProps {
    location: Location;
    history: History;
}

type Props = OwnProps;

class ScrollToTop extends React.Component<Props> {

    private hasScrollRestoration: boolean;

    public static getScrollTop() {
        return 'scrollY' in window
            ? window.scrollY  // normal browsers
            : document.documentElement.scrollTop; // IE
    }

    constructor(props: Props) {
        super(props);

        // some browsers (e.g. chrome) can now restore scroll position themself
        this.hasScrollRestoration = typeof window !== 'undefined' && 'scrollRestoration' in window.history;
        if (this.hasScrollRestoration) {
            // window.history.scrollRestoration = 'auto';

            // CeMi: Zatial pouzivame vsade "nas" scrollRestoration kod, ma lepsie UX.
            //
            // Chrome kod totiz niekedy na 'go forward' nastavi ako scrollTop namiesto 0
            // nejaky iny (necakany) offset
            window.history.scrollRestoration = 'manual';
            this.hasScrollRestoration = false;
        }
    }

    public componentDidMount() {
        if (this.hasScrollRestoration) {
            return;
        }

        const { location, history } = this.props;

        if (history && history.action === 'REPLACE') {
            // zachovaj scroll position, ked sa len vymenilo url
            // (chceme zobrazovat aktualne URL pre vyklikany filter)
            return;
        }

        // locationState might be null in old browsers (android 4.0)
        const locationState: HistoryLocationState = location.state;

        if (locationState && locationState.dontScrollOnPush && history.action === 'PUSH') {
            return;
        }

        const scroll = getSessionStorage().getItem(`ScrollToTop__scroll__${location.key}`);
        if (scroll) {
            const y = parseFloat(scroll);
            window.scrollTo(0, y);
        }
    }

    public componentWillReceiveProps(nextProps: Props) {
        if (this.hasScrollRestoration) {
            return;
        }

        // Store scroll position
        if (nextProps.location.key !== this.props.location.key) {
            getSessionStorage().setItem(`ScrollToTop__scroll__${this.props.location.key}`, `${ScrollToTop.getScrollTop()}`);
        }
    }

    public componentDidUpdate(prevProps: Props) {
        if (this.hasScrollRestoration) {
            return;
        }

        const { location, history } = this.props;

        if (history && history.action === 'REPLACE') {
            // zachovaj scroll position, ked sa len vymenilo url
            // (chceme zobrazovat aktualne URL pre vyklikany filter)
            return;
        }

        const locationState: HistoryLocationState = location.state;

        if (locationState && locationState.dontScrollOnPush && history.action === 'PUSH') {
            return;
        }

        if (location.key !== prevProps.location.key) {
            const scroll = getSessionStorage().getItem(`ScrollToTop__scroll__${location.key}`);
            const y = scroll ? parseFloat(scroll) : 0;
            window.scrollTo(0, y);
        }
    }

    public render() {
        const { children } = this.props;
        return children ? React.Children.only(children) : null;
    }

}

export default ScrollToTop;
